

<div class="center" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>


<div class="edit-measurement-modal">
  <div class="measurement-modal__header">
    <span class="measurement-modal__title">{{editingMeasurementPoint?.Name}}</span>
    <i class="material-icons measurement-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <div class="measurement-modal__body" [hidden]="isLoading">
    <ul class="select-tool-container">
     
      <li class="select-tool" *ngFor="let tool of addedTools; let i = index" [class.active]="tool.ToolId == selectedToolId" (click)="setSelectedToolId(tool.ToolId)">{{tool.ToolName}}</li>
      <i class="material-icons  add-tool__icon" [matTooltip]="'Add A New Tool' | translate | async" [matMenuTriggerFor]="toolsMenu"
      *ngIf="trackTools?.length>0" >add</i>
      <div *ngIf="addedTools?.length == 0" style="padding-top: 10px; margin-left: 20px "> - Please add a tool to add calculation methods </div>
      <mat-menu #toolsMenu="matMenu">
        <button mat-menu-item *ngFor="let tool of trackTools" (click)="addANewCalculationMethod(tool)">
          <span>{{tool.ToolName}}</span>
        </button>
      </mat-menu>
    </ul>

    <mat-divider style="margin-top: 20px"></mat-divider>
    <div [hidden] ="selectedCalculationMethodObj == null" > 
      <calculation-method-forms (savingAllCalculation)="savingAll($event)" (savedAll)="savedAll($event)" #all [currentlyEditingMethod]="selectedCalculationMethodObj"  ></calculation-method-forms>  
    </div>
   </div>


  <div class="measurement-modal__footer">
    <button mat-raised-button (click)="onNoClick()">Cancel</button>
    <button mat-raised-button color="warn" [class.loading]="saving" (click)="saveAllCalculationMethods()">
      <span class="material-icons button__icon">check</span>
      <span class="button__text">Save</span>
    </button>
  </div>
</div>